import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "tab"]
  select(event) {
    const format = event.currentTarget.dataset.format
    this.panelTargets.forEach(panel => { panel.hidden = panel.dataset.format !== format })
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.format === format
      tab.classList.toggle("is-active", active)
      tab.setAttribute("aria-pressed", String(active))
    })
  }
}
